import React, { memo } from 'react'
import { Path } from 'react-native-svg'

import { IconBase } from '../IconBase'
import { IconProps } from '../IconProps'
import { themed } from '../themed'

const Icon = (props) => {
  const { color = 'black', size = 24, ...otherProps } = props
  return (
    <IconBase
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      {...otherProps}
    >
      <Path
        fill={`${color}`}
        d="M15.097 3C14.882 3.38911 14.689 3.79163 14.5135 4.2031C12.8462 3.94818 11.1483 3.94818 9.47668 4.2031C9.30557 3.79163 9.10813 3.38911 8.89316 3C7.32684 3.27283 5.8 3.75138 4.35215 4.42672C1.48276 8.76059 0.706179 12.9826 1.09228 17.1465C2.77266 18.4123 4.65489 19.3783 6.65994 19.9955C7.11185 19.3783 7.51111 18.7209 7.85333 18.0366C7.20398 17.7906 6.57658 17.482 5.9755 17.1242C6.13345 17.0079 6.28701 16.8871 6.43618 16.7708C9.9593 18.4615 14.0396 18.4615 17.5671 16.7708C17.7163 16.8961 17.8699 17.0168 18.0278 17.1242C17.4267 17.4864 16.7993 17.7906 16.1456 18.0411C16.4878 18.7253 16.8871 19.3828 17.339 20C19.344 19.3828 21.2262 18.4212 22.9067 17.1555C23.3629 12.3252 22.1257 8.1389 19.6379 4.43121C18.1945 3.75586 16.6677 3.27729 15.1014 3.00894L15.097 3ZM8.34472 14.5838C7.26103 14.5838 6.3616 13.582 6.3616 12.3431C6.3616 11.1042 7.22592 10.0979 8.34034 10.0979C9.45476 10.0979 10.341 11.1087 10.3235 12.3431C10.3059 13.5775 9.45037 14.5838 8.34472 14.5838ZM15.6542 14.5838C14.5661 14.5838 13.6755 13.582 13.6755 12.3431C13.6755 11.1042 14.5398 10.0979 15.6542 10.0979C16.7686 10.0979 17.6505 11.1087 17.6329 12.3431C17.6154 13.5775 16.7598 14.5838 15.6542 14.5838Z"
      />
    </IconBase>
  )
}

Icon.displayName = 'IconDiscord'

export const IconDiscord = memo(themed(Icon))
